module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-fenix-soft.c997f556.jpg";